import { render, staticRenderFns } from "./Studhorse.vue?vue&type=template&id=71966aa8&"
import script from "./Studhorse.vue?vue&type=script&lang=js&"
export * from "./Studhorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports